import { createCustomToggle, headerSearchBarFix, updateContentMargin } from './helpers';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');

  $(globalThis).on('load', function () {
    updateContentMargin();
  });

  createCustomToggle();
  headerSearchBarFix('Search on this website...');
});
